import { Navigate, Outlet } from 'react-router-dom';
import { useUserContext } from '@/contexts/UserContext';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

const PrivateRoute = () => {
	const { user } = useUserContext(); // Adjust based on how you handle user authentication

	useEffect(() => {
		if (!user) {
			toast.info("Vous n'avez pas accès à cette zone", {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});
		}
	}, []);

	return user ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
